import styled from "@emotion/styled";
import theme from "../theme";
import { NotificationBadge } from "./common/NotificationBadge";

const { sm, md, lg } = theme.screen;

const ReusableCard: React.FC<{
  title: string;
  icon: JSX.Element;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  fillCircle?: boolean;
  newNotice?: boolean;
}> = (props) => {
  const {
    title,
    icon,
    onClick,
    onMouseEnter,
    onMouseLeave,
    fillCircle,
    newNotice,
  } = props;

  return (
    <CardContainer>
      <Card
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        fillCircle={fillCircle}
      >
        <CardName>
          {title}
          {newNotice && (
            <NotificationBadge
              width={"6px"}
              height={"6px"}
              top={"0"}
              right={"-6px"}
            />
          )}
        </CardName>

        <IconWrapper>{icon}</IconWrapper>
      </Card>
      <CardNameForMobile>
        {title}
        {newNotice && (
          <NotificationBadge
            width={"4px"}
            height={"4px"}
            top={"6px"}
            right={"17px"}
          />
        )}
      </CardNameForMobile>
    </CardContainer>
  );
};

const Card = styled.button<{ fillCircle?: boolean }>`
  display: flex;
  width: 100%;
  height: 259px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 30px;
  position: relative;
  transition: 200ms;

  cursor: pointer;
  &:hover {
    background: ${theme.statusColor.MAIN};
    scale: 103%;
  }
  &:hover span {
    color: ${theme.color.white};
  }
  &:hover div svg path {
    fill: ${theme.color.white};
    stroke: ${({ fillCircle }) =>
      fillCircle ? "" : theme.statusColor.MAIN};
  }
  &:hover div svg circle {
    fill: ${({ fillCircle }) =>
      fillCircle ? theme.color.white : theme.statusColor.MAIN};
  }
  &:hover div svg rect {
    fill: ${({ fillCircle }) =>
      fillCircle ? theme.color.white : theme.statusColor.MAIN};
  }

  @media (max-width: ${sm}px) {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    background: ${theme.statusColor.MAIN};
    span {
      color: ${theme.color.white};
    }
    div svg path {
      fill: ${theme.color.white};
      stroke: ${({ fillCircle }) =>
        fillCircle ? "" : theme.statusColor.MAIN};
    }
    div svg circle {
      fill: ${({ fillCircle }) =>
        fillCircle ? theme.color.white : theme.statusColor.MAIN};
    }
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    height: 100px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (min-width: ${md + 1}px) and (max-width: 890px) {
    padding: 40px 10px;
  }
`;

const CardName = styled.span`
  transition: 200ms;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: ${theme.color.neutral_600};
  position: relative;

  @media (max-width: ${sm}px) {
    display: none;
  }
  @media (min-width: ${sm + 1}px) and (max-width: 800px) {
    font-size: 14px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: 910px) {
    font-size: 15px;
    padding-left: 10px;
  }
`;

const IconWrapper = styled.div`
  transition: 200ms;

  @media (max-width: ${sm}px) {
    width: 30px;
    height: 30px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: 830px) {
    position: absolute;
    bottom: 30px;
    right: 10px;
  }
  @media (min-width: 830px) and (max-width: ${lg}px) {
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
  @media (min-width: ${lg + 1}px) {
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
`;
const CardNameForMobile = styled.div`
  display: none;
  @media (max-width: ${sm}px) {
    width: 80px;
    display: block;
    font-size: 10px;
    text-align: center;
    padding-top: 10px;
    position: relative;
    color: ${theme.color.neutral_600};
  }
`;

const CardContainer = styled.div`
  @media (max-width: ${sm}px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export default ReusableCard;
